import React from 'react';
import { navigationEvent } from 'services/dataLayerService';
import Button from 'components/Core/Button';
import { ChildMenuContainer, ButtonsContainer } from './styles';
import AccordionMenu from './AccordionMenu';
import StandardMenu from './StandardMenu';

const ChildNav = ({ selectedSubMenu, setMobileMenuOpened }) => {
  const { ctas, subNavigationElement, label } = selectedSubMenu || {};
  const groups = Array.from(new Set(subNavigationElement?.map((x) => x.group?.group)));
  const useAccordionMenu = label && ['residential', 'commercial'].includes(label.toLowerCase());
  let menuCtas = ctas;

  if (label === 'Solutions') {
    menuCtas = [ctas?.[subNavigationElement?.[0]?.businessType === 'Commercial' ? 0 : 1]];
  }

  return (
    <ChildMenuContainer className="mobile-child-nav">
      {useAccordionMenu ? (
        <AccordionMenu
          selectedMenu={label}
          groups={groups}
          subNavigationElement={subNavigationElement}
          setMobileMenuOpened={setMobileMenuOpened}
        />
      ) : (
        <StandardMenu
          groups={groups}
          selectedSubMenu={selectedSubMenu}
          subNavigationElement={subNavigationElement}
          setMobileMenuOpened={setMobileMenuOpened}
        />
      )}
      {selectedSubMenu?.label !== 'Solutions' && (
        <ButtonsContainer>
          {menuCtas?.[0] !== undefined &&
            menuCtas?.map((cta) => {
              return (
                <Button
                  dataPosition="Header - Menu Item CTA"
                  type="transparent - black border"
                  to={cta.url}
                  onClick={() => {
                    navigationEvent(cta.buttonLabel, cta.url);
                    setMobileMenuOpened(false);
                  }}
                  className="header-menu-cta"
                >
                  <p className="font-sm">
                    <b>{cta.buttonLabel}</b>
                  </p>
                </Button>
              );
            })}
        </ButtonsContainer>
      )}
    </ChildMenuContainer>
  );
};

export default ChildNav;
